export const DOCUMENT_TYPES = {
  INVOICE        : 'invoice',
  SHIPPING_LABEL : 'shippingLabel'
}